<template>
	<div id="mainCanvas" @contextmenu.prevent="">
		<!--背景图绘制层-->
		<canvas id="defectCanvas" class="absoluteCanvas" v-bind:width="canvasWidth" v-bind:height="canvasHeight" />
		<!--绘制矩形层-->
		<canvas id="pointsCanvas" class="absoluteCanvas" v-bind:width="canvasWidth" v-bind:height="canvasHeight" />
		<!--标尺信息-->
		<rule-bar-layout class="ruleCanvas" :length="totalLength" v-show="ruleBarVisible" v-bind:width="canvasWidth" v-bind:height="50" />
		<!--框选和显示密度层-->
		<select-area-layout class="absoluteCanvas" :width="canvasWidth" :height="canvasHeight" :imageLocation="imageLocation" :scale="scale" />
	</div>
</template>

<script>
	import RuleBarLayout from './RuleBarLayout'
	import SelectAreaLayout from './SelectAreaLayout'
	import { store } from './store'

	export default {
		components: {
			RuleBarLayout,
			SelectAreaLayout,
		},
		data() {
			return {
				/**
				 * 界面宽度。
				 */
				clientWidth: 0,
				/**
				 * 画布宽度。
				 */
				canvasWidth: 0,
				/**
				 * 画布高度。
				 */
				canvasHeight: 0,
				/**
				 * 默认画布，背景图画布。
				 */
				canvas: null,
				/**
				 * 存放鼠标位置。
				 */
				origin: [],
				/**
				 *
				 */
				pointsCanvas: null,
				/**
				 *
				 */
				scale: 1,
				/**
				 *
				 */
				imageLocation: {
					x: 0,
					y: 0,
					w: 0,
					h: 0,
				},
				/**
				 * 当前版图。
				 */
				image: null,
				/**
				 * 版图是否加载完成。
				 */
				imageLoaded: false,
			}
		},
		computed: {
			/**
			 * 图片地址（可以是base64，也可以是uri地址）
			 */
			imageUrl() {
				return store.state.originalImageBase64
			},
			/**
			 * 批次总长度。
			 */
			totalLength() {
				return store.state.totalLength
			},
			/**
			 * 选中的缺陷记录Id。
			 */
			selectedDefectId() {
				return store.state.selectedDefectId
			},
			/**
			 * 是否显示标尺。
			 */
			ruleBarVisible() {
				return store.state.ruleBarVisible
			},
			/**
			 * 是否显示密度点。
			 */
			showPoints() {
				return store.state.defectPointVisible
			},
			/**
			 * 缺陷点记录。
			 */
			pointsData() {
				var defects = store.state.filteredDefects

				var data = defects.map(p => {
					return {
						id: p._id.$oid,
						x: p.pos_x + p.size_cx / 2,
						y: p.pos_y + p.size_cy / 2,
					}
				})

				return data
			},
		},
		watch: {
			/**
			 * 检查图片地址如果有变更，重新加载版图。
			 */
			imageUrl(val) {
				if (val) {
					this.imageLoaded = false
					this.initCanvas(val)
				}
			},
			/**
			 * 监控选中的缺陷记录，实时显示缺陷记录在版图中的位置信息。
			 */
			selectedDefectId(val) {
				if (val) {
					//选中的缺陷记录信息。
					var data = store.getDefectInfo(val)

					var def = {
						x: data.pos_x,
						y: data.pos_y,
						h: data.size_cy,
						w: data.size_cx,
						type: 1,
					}

					//绘制矩形
					this.drawRect2(def.x, def.y, def.w, def.h, def.type, this.pointsCanvas)
					//抠图。
					this.cutRectImage(def.x, def.y, def.w, def.h)
				}
			},
			/**
			 * 通过显示缺陷点来控制是否绘制缺陷点。
			 */
			showPoints(val) {
				if (this.pointsData.length == 0) return
				this.drawPoints()
			},
		},
		methods: {
			/**
			 * 初始化canvas大图。
			 */
			initCanvas(dataURLs) {
				if (dataURLs.substr(0, 4) != 'http') {
					if (dataURLs.substr(0, 5) != 'data:') {
						dataURLs = 'data:image/png;base64,' + dataURLs
					}
				}

				this.image = new Image()
				this.image.src = dataURLs
				this.image.setAttribute('crossOrigin', 'anonymous')
				this.image.onload = () => {
					//减去标尺的高度
					var h = this.canvasHeight
					var scale = h / this.image.height
					console.log('canvasHeight', this.canvasHeight)
					console.log('this.image.height', this.image.height)
					console.log('this.image.width', this.image.width)

					//根据图片的高宽比例，显示最合适的大小。
					if (scale * this.image.width > this.canvasWidth) {
						scale = (scale * this.image.width) / this.canvasWidth
					}

					console.log('scale', scale)

					//计算开始绘制点，为保证图片居中。
					var left = this.canvasWidth / 2 - (this.image.width * scale) / 2
					var top = this.canvasHeight / 2 - (this.image.height * scale) / 2
					var width = this.image.width * scale
					var height = this.image.height * scale

					//设置图片在canvas中的位置和大小。
					this.imageLocation.x = left
					this.imageLocation.y = top
					this.imageLocation.w = width
					this.imageLocation.h = height

					//设置缩放比例。
					this.scale = scale
					//绘制图片。
					this.drawImage(this.image)

					this.imageLoaded = true
					console.log('图片加载完成')
				}
			},
			/**
			 * 绘制一个中心点。
			 */
			drawCenterPoint(x, y) {
				var ctx = this.pointsCanvas.getContext('2d')
				ctx.strokeStyle = 'rgb(122, 225, 90)'
				ctx.fillStyle = 'rgb(122, 225, 90)'
				ctx.beginPath()
				ctx.arc(x, y, store.state.pointRadius, 0, 2 * Math.PI)
				ctx.fill()
				ctx.stroke()
			},
			/**
			 * 绘制图片。
			 */
			drawImage(image) {
				var cxt = this.canvas.getContext('2d')
				cxt.setTransform(1, 0, 0, 1, 0, 0)

				//先清空画布。
				cxt.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
				// 恢复先前渲染上下文所进行的变换
				cxt.restore()
				cxt.drawImage(image, this.imageLocation.x, this.imageLocation.y, this.imageLocation.w, this.imageLocation.h)
			},
			/**
			 * 进行抠图裁剪。
			 */
			cutRectImage(x, y, width, height) {
				var w = 285
				var h = 285
				x = x - w / 2 + width / 2
				y = y - h / 2 + height / 2
				var cv = document.createElement('canvas')
				cv.height = h
				cv.width = w

				var ctx = cv.getContext('2d')
				ctx.fillStyle = '#fff'
				ctx.fillRect(0, 0, w, h)
				var self = this

				//通过定时器检查大图是否加载完成。
				var timer = setInterval(function() {
					if (self.imageLoaded) {
						clearInterval(timer)
						ctx.drawImage(self.image, x, y, w, h, 0, 0, w, h)
						var imageBase64 = cv.toDataURL('image/png')

						store.setSelectedDefectCutoutImage(imageBase64)
					}
				}, 10)
			},
			/**
			 * 绘制目标区域
			 */
			drawRect2(x, y, cx, cy, type, cav) {
				var width = 285
				var height = 285
				var w = width * this.scale
				var h = height * this.scale

				//将缺陷点的坐标转换成x，y坐标。
				x = this.imageLocation.x + x * this.scale - (width / 2) * this.scale + (cx / 2) * this.scale
				y = this.imageLocation.y + y * this.scale - (height / 2) * this.scale + (cy / 2) * this.scale

				// y = 左上角 Y 坐标 + 缺陷 Y 坐标 - 目标框的一半  + 缺陷高度
				var ctx = this.pointsCanvas.getContext('2d')
				//清空上次绘制记录。
				//ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
				//重新绘制底图。
				//this.drawImage(this.image);
				//重新绘制所有的数据坐标点。
				if (this.showPoints) {
					this.drawPoints()
				} else {
					ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
				}
				ctx.fillStyle = 'rgba(255, 255, 255, 0)'
				ctx.strokeStyle = 'red'
				ctx.lineWidth = 1
				if (type == 1) {
					ctx.strokeStyle = 'red'
					ctx.lineWidth = 1
				} else {
					ctx.strokeStyle = 'yellow'
					ctx.lineWidth = 1
				}
				ctx.strokeRect(x, y, w, h)
				//绘制中心点
				this.drawCenterPoint(x + w / 2, y + h / 2)
			},
			/**
			 * 绘制所有的缺陷点。
			 */
			drawPoints() {
				var ctx = this.pointsCanvas.getContext('2d')
				//清空上次绘制记录。
				ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
				if (this.showPoints) {
					ctx.strokeStyle = '#f00'
					ctx.fillStyle = '#f00'
					this.pointsData.forEach(coord => {
						ctx.beginPath()
						ctx.arc(this.imageLocation.x + coord.x * this.scale, this.imageLocation.y + coord.y * this.scale, store.state.pointRadius, 0, 2 * Math.PI)
						ctx.fill()
						ctx.stroke()
					})
				}
			},
		},
		mounted() {
			this.clientWidth = document.documentElement.clientWidth
			this.canvasWidth = document.getElementById('mainCanvas').offsetWidth
			this.canvasHeight = document.getElementById('mainCanvas').offsetHeight
			this.canvas = document.getElementById('defectCanvas')
			this.pointsCanvas = document.getElementById('pointsCanvas')

			this.initCanvas(this.imageUrl)
		},
	}
</script>

<style scoped>
	.absoluteCanvas {
		position: absolute;
		left: 0;
		top: 0;
	}
	.ruleCanvas {
		position: absolute;
		left: 0;
		right: 0;
		height: 50px;
		bottom: 0;
	}
</style>
